import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ButtonAdd } from '../Buttons';

interface IResourceDatabaseItemsViewHeadSectionProps {
  itemCount: number;
  addButtonCallback: (() => void) | null;
}

const ResourceDatabaseItemsViewHeadSection = ({
  itemCount,
  addButtonCallback,
}: IResourceDatabaseItemsViewHeadSectionProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <HeadSection>
      <ItemsTitle>
        {t('resources.content.itemsWithCount', {
          count: itemCount,
        })}
      </ItemsTitle>
      {addButtonCallback && (
        <ButtonAdd size="s" onClick={addButtonCallback}>
          {t`resources.content.addItem`}
        </ButtonAdd>
      )}
    </HeadSection>
  );
};

export { ResourceDatabaseItemsViewHeadSection };

const HeadSection = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px 0;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

const ItemsTitle = styled.h3`
  font-size: 20px;
  font-weight: 300;
  color: #1f4a9fcc;
  margin: 0;
`;
